import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { TypeCompModel } from '../../../models/simple-types/type-comp.model';
import { TypeCompService } from '../../../services/simple/type-comp.service';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { GestionTypeCompComponent } from 'src/app/core/gestion-referentiel/gestion-type-comp/gestion-type-comp.component';

export interface DialogData {
  form: UntypedFormGroup;
  typeComps: TypeCompModel[];
  result: boolean;
}
@Component({
  selector: 'app-modal-add-type-comp',
  templateUrl: './modal-add-type-comp.component.html',
  styleUrls: ['./modal-add-type-comp.component.scss']
})
export class ModalAddTypeCompComponent implements OnInit {

  typeComps: TypeCompModel[];
  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionTypeCompComponent>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private typeCompService: TypeCompService) {
             }

    ngOnInit(): void {
      this.typeComps = this.data.typeComps;
      this.form = this.data.form;
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const typeComp = this.form.getRawValue();
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.typeCompService.save(typeComp).subscribe((a: TypeCompModel) => {
              this.toastr.success('', 'Création du type de complément ' + a.code + ' réussie');
              this.dialogRef.close(true);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(true);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.typeCompService.update(typeComp.id, typeComp).subscribe((a: TypeCompModel) => {
            this.toastr.success('', 'Modification du type de complément ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}


